export default {
methods: {
	setLanguage() {
		if (document.body.classList.contains('wpml-nl')) {
			return 'nl';
		} else if (document.body.classList.contains('wpml-en')) {
			return 'en';
		} else if (document.body.classList.contains('wpml-de')) {
			return 'de';
		}
	}
}
};